import DesignProductAction from './DesignProductAction'

export default DesignProductAction
